import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import "dayjs/locale/fr";
import translationEN from "locales/en/translation.json";
import translationFR from "locales/fr/translation.json";
import translationAR from "locales/ar/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    react: {
      bindI18n: "loaded languageChanged",
      bindI18nStore: "added",
      useSuspense: true,
    },
    resources,
    // lng: "en",
    debug: true,
    supportedLngs: ["en", "fr", "ar"],
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

// Sync dayjs locale with i18n language
dayjs.locale(i18n.language);
i18n.on("languageChanged", (lng) => {
  dayjs.locale(lng);
});

export default i18n;
